import { reactive, shallowReadonly } from 'vue';
import { Database } from '.';

export abstract class Store<T extends object> {
  protected state: T;

  constructor() {
    const data = this.data();
    this.setup(data);
    this.state = reactive(data) as T;
  }

  protected abstract data(): T;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  protected setup(data: T): void {
    // Overridable by child
  }

  public getState(): T {
    // XXX regular readonly breaks when assigning copies to other reactive values,
    //     i.e. they are not equal because they are wrapped in a proxy.
    //     e.g. state.value = someStore.value; state.value !== someStore.value
    return shallowReadonly(this.state) as T;
  }
}

export abstract class PersistentStore<T extends object> extends Store<T> {
  constructor(protected readonly db: Database) {
    super();
  }
}
